import { render, staticRenderFns } from "./showGift.vue?vue&type=template&id=389377b9&scoped=true&"
import script from "./showGift.vue?vue&type=script&lang=js&"
export * from "./showGift.vue?vue&type=script&lang=js&"
import style0 from "./showGift.vue?vue&type=style&index=0&id=389377b9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389377b9",
  null
  
)

export default component.exports